(() => {
  const slider = document.getElementById("hero-slider");
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll(".hero-slide"));
  const dots = Array.from(slider.querySelectorAll("[data-hero-slide]"));
  const status = slider.querySelector("[data-hero-status]");
  const autoplayButton = slider.querySelector("[data-hero-autoplay]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let current = 0;
  let touchStart = null;
  let paused = reducedMotion.matches;
  let hovered = false;
  let timer;

  function updateAutoplay() {
    window.clearTimeout(timer);
    autoplayButton.setAttribute("aria-label", paused ? "Start autoplay" : "Pause autoplay");
    autoplayButton.firstElementChild.textContent = paused ? "▶" : "Ⅱ";
    const playing = !paused && !hovered && !touchStart &&
      !slider.contains(document.activeElement) && !document.hidden;
    status.setAttribute("aria-live", playing ? "off" : "polite");
    if (!playing) return;
    timer = window.setTimeout(() => {
      const bounds = slider.getBoundingClientRect();
      // Never pull readers back to the hero or change it while they scroll past.
      if (bounds.top >= 0 && bounds.top < window.innerHeight) {
        showSlide(current + 1, true);
      } else {
        updateAutoplay();
      }
    }, 6000);
  }

  function showSlide(index, automatic = false) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => { slide.hidden = i !== current; });
    dots.forEach((dot, i) => {
      if (i === current) dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
    status.textContent = `Slide ${current + 1} of ${slides.length}`;
    // The existing homepage animations measure positions on scroll.
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    if (!automatic && slider.getBoundingClientRect().top < 0) {
      slider.scrollIntoView({ block: "start", behavior: "instant" });
    }
    updateAutoplay();
  }

  slider.querySelector("[data-hero-prev]").addEventListener("click", () => showSlide(current - 1));
  slider.querySelector("[data-hero-next]").addEventListener("click", () => showSlide(current + 1));
  dots.forEach((dot, index) => dot.addEventListener("click", () => showSlide(index)));
  slider.addEventListener("keydown", (event) => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
    event.preventDefault();
    if (slides[current].contains(document.activeElement)) dots[current].focus();
    showSlide(current + (event.key === "ArrowRight" ? 1 : -1));
  });
  slider.addEventListener("touchstart", (event) => {
    touchStart = event.touches.length === 1
      ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
      : null;
    updateAutoplay();
  }, { passive: true });
  slider.addEventListener("touchcancel", () => { touchStart = null; updateAutoplay(); });
  slider.addEventListener("touchend", (event) => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
      if (slides[current].contains(document.activeElement)) dots[current].focus();
      showSlide(current + (dx < 0 ? 1 : -1));
    }
    updateAutoplay();
  }, { passive: true });
  autoplayButton.addEventListener("click", () => { paused = !paused; updateAutoplay(); });
  slider.addEventListener("mouseenter", () => { hovered = true; updateAutoplay(); });
  slider.addEventListener("mouseleave", () => { hovered = false; updateAutoplay(); });
  slider.addEventListener("focusin", updateAutoplay);
  slider.addEventListener("focusout", () => window.setTimeout(updateAutoplay, 0));
  document.addEventListener("visibilitychange", updateAutoplay);
  reducedMotion.addEventListener("change", () => { paused = reducedMotion.matches; updateAutoplay(); });
  slider.querySelector(".hero-slider-controls").hidden = false;
  updateAutoplay();
})();
